export default () => {
  return Math.random().toString(36).substr(2, 9);
};



// WEBPACK FOOTER //
// ./src/lib/react-picture-annotation/utils/randomId.ts